import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=3c76bd08&scoped=true&"
import script from "./video-modal.vue?vue&type=script&lang=js&"
export * from "./video-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c76bd08",
  null
  
)

export default component.exports